export default {
  general: {
    back: 'Back to My Account',
    backFarm: 'Back to Farm',
  },
  user: {
    settings: 'Account settings'
  },
  summary: {
    title: 'Finance overview',
    yesterday: 'Yesterday’s  income',
    total: 'Total income',
    withdrawn: 'Withdrawn',
    balance: 'Balance',
    withdrawNow: 'Withdraw Now',
    income: "Income",
    todayEstimate: "Today’s estimate:",
    finance: "Finance",
    incomeHistory: "Income history",
    withdrawalHistory: "Withdrawal history",
    totalIncomeHint1: "Total income does not includes today income.",
    totalIncomeHint2: "Today income will be credited to your balance at 00:00 UTC (London time)",
  },
  farms: {
    title: 'Your farms',
    share: 'Farm stake',
    yesterday: 'Yesterday income',
    total: 'Total income',
    view: 'View Farm'
  },
  table: {
    total: 'Total',
    noData: 'Records not found'
  },
  income: {
    title: 'Income records',
    amount: 'Amount',
    date: 'Date',
    farm: 'Farm',
  },
  withdrawals: {
    title: 'Withdraw records',
    amount: 'Amount',
    date: 'Date',
    address: 'Address',
    status: 'Status',
    pending: 'Pending',
    paid: 'Paid',
    withdrawNow: 'Withdraw Now'
  },
  account: {
    title: 'Account settings',
    enterName: 'Your name',
    saveChanges: 'Save changes',
    cancelChanges: 'Cancel',
    changesSaved: 'Changes saved',
    saving: 'Saving...',
    retypeNewPassword: 'Retype new password',
    passwordSaved: 'New password saved',
    deleteAccount: 'Do you want delete your account?',
    contactSupport: 'Contact support',
    questions: 'Have any questions regarding your orders?',
    getHelp: 'Get help',
    wrongPassword: 'Wrong password',
    oldPassword: 'Old password',
    min6chars: 'Minimum 6 chars',
    newPassword: 'New password',
    loginMethods: 'Login methods',
    viaPassword: "Password",
    viaSocial: 'Authorization via ',
    enterCurrentPassword: 'Enter current password',
    change: 'Change',
    remove: 'Remove',
    setPassword: 'Create',
    removeWarning: 'If you remove password you will be able to login only via Google',
    removePassword: 'Remove password',
    removingPassword: 'Removing password...',
    cancel: 'Cancel',
    disable: 'Disable',
    enable: 'Enable',
    twitterTokenAccess: 'Twitter Bot Access Token',
    generateToken: 'Generate Token',
    deleteToken: 'Delete Token',
  },
  farmInfo: {
    'deviceDetails': 'Device details',
    'model': 'Model',
    'hashrate': 'Hashrate',
    'power': 'Power',
    'watts': 'watts',
    'price': 'Price',
    'desc': 'Group Mining Farm "%miniFarmTitle%" consists of %devices%. It is one of the most popular mining machines.',
    'desc2': 'You become a partner with Xive and co-own the "%miniFarmTitle%" farm based on ' +
      'the share percentage you purchased. ' +
      'The devices and hosting prices remain the same as Xive\'s cost price. ',
    'desc3': 'Xive only applies a %miniFarmServiceFee% management fee on the profits generated.',
    'deviceDesc': '%count% devices of %model% with hashrate %rate% each',
    'groupMiningDetails': 'Group mining farm details',
    'totalHashrate': 'Total hashrate',
    'totalValue': 'Total value',
    'devices': 'Devices',
    'hostingDetails': 'Hosting details',
    'electricityFee': 'Hosting fee',
    'kwh': 'kW/h',
    'securityDeposit': 'Deposit',
    'days': 'days',
    'profitSharing': 'Profit sharing',
  },
  farmSummary: {
    title: 'Mining farm "%"&nbsp;overview',
    yesterday: 'Yesterday\'s income',
    total: 'Total income',
    deposit: 'Security deposit',
    stake: 'Farm stake'
  },
  farmIncome: {
    title: 'Income records',
    amount: 'Amount',
    date: 'Date'
  },
  farmOrders: {
    title: 'Order records',
    date: 'Date',
    stake: 'Farm Stake',
    amount: 'Order Amount',
    deposit: 'Deposit Amount'
  },
  withdrawal: {
    sendBtc: 'Send BTC',
    loadingBalance: 'Loading balance...',
    network: 'Network:',
    selectNetwork: 'Select Network',
    bitcoinNetwork: 'Bitcoin network',
    binanceNetwork: 'BNB Smart Chain (BEP20)',
    address: 'Address:',
    invalidAddress: 'Invalid address',
    walletOk: 'Address OK',
    mainnetRequired: 'MainNet wallet required',
    mustBeBitcoinNetwork: 'Wallet address must be valid <b>Bitcoin network</b> address',
    mustBeBinanceNetwork: 'Wallet address must be valid <b>Binance BEP 20 (BSC)</b> wallet',
    transactionsIrreversible: 'All BTC transaction are irreversible: if your enter wrong ' +
      'BTC wallet address your money <b>will be lost</b>!',
    sendFrom: 'Send from:',
    selectWallet: 'Select wallet',
    amount: 'Amount:',
    max: 'Max',
    available: 'Available:',
    minAmount: 'Minimum amount:',
    notEnoughBalance: 'Your balance is not enough for withdrawal',
    receiveAmount: 'Receive Amount:',
    calculating: 'calculating...',
    networkFee: 'Network fee',
    continue: 'Continue',
    checking: 'Checking...',
    confirmWithdrawal: 'Confirm withdrawal',
    verifyWithdrawal: 'Please verify your withdrawal',
    sixDigitsSent: 'A six digits code has been sent your email, please check your inbox',
    confirm: 'Confirm',
    withdrawalRequested: 'Withdrawal requested',
    willBeWithdrawn: 'The amount you have requested with be withdrawn in few hours',
    close: 'Close',
    wrongCode: 'You have entered wrong code, please check the code',
    enterCryptoAddress: 'Enter crypto address',
    enterAmount: 'Enter amount',
  }
}